import React from "react";

const PhotoPitcher = props =>{
    return(
        <div id="testFB" className="fadeEgg" style={{width: "fit-content", height: "fit-content", position: "relative", overflow:"hidden"}}>
            <img rel="preload" alt="easter egg" className="img-fluid" src={props.photo} key={props.photo} />
            <span className={`pin step${props.whatStep + 1}__pin__1 ${props.isModalOpen && `pin--true`}`} onClick={props.openModal} />
            <span className={`pin step${props.whatStep + 1}__pin__2`} onClick={(event) => event.currentTarget.classList.add(`pin--false`)} /> 
            <span className={`pin step${props.whatStep + 1}__pin__3`} onClick={(event) => event.currentTarget.classList.add(`pin--false`)} /> 
            <span className={`pin step${props.whatStep + 1}__pin__4`} onClick={(event) => event.currentTarget.classList.add(`pin--false`)} /> 
        </div>
    )
}

export default PhotoPitcher